import React from "react";
import { useTranslation } from "react-i18next";
import {
  formatMetricDelta,
  getAnomalyMetrics,
  METRIC_LABEL_KEYS,
} from "util/cxAlertModel";
import cxStyles from "./cxAlert.module.scss";

export default function AlertMetricLines({ payload, compact = false, popup = false }) {
  const { t } = useTranslation();
  const anomalies = getAnomalyMetrics(payload);
  const lineClass = popup ? cxStyles.panelMetaPopup : cxStyles.metricLine;

  if (!anomalies.length) {
    return compact || popup ? null : (
      <p className={lineClass}>{t("alerts_page.no_metric_detail")}</p>
    );
  }

  return (
    <>
      {anomalies.map(([key, metric]) => (
        <div key={key} className={lineClass}>
          {popup ? (
            <>
              {t(METRIC_LABEL_KEYS[key] || key)}: {formatMetricDelta(key, metric, t)}
            </>
          ) : (
            <>
              <span className={cxStyles.metricLabel}>
                {t(METRIC_LABEL_KEYS[key] || key)}
              </span>
              {formatMetricDelta(key, metric, t)}
            </>
          )}
        </div>
      ))}
    </>
  );
}
